import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectTimeline = ({ projects }) => {
  const years = [...new Set(projects.map(p => p.year))]?.sort((a, b) => b - a);

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 lg:p-8 mb-8 md:mb-12">
      <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground mb-6 md:mb-8">
        Project Timeline
      </h2>
      <div className="space-y-6 md:space-y-8">
        {years?.map((year, index) => {
          const yearProjects = projects?.filter(p => p?.year === year);
          return (
            <div key={year} className="relative">
              <div className="flex items-center gap-3 md:gap-4 mb-4">
                <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/10 border-2 border-primary">
                  <span className="text-sm md:text-base font-bold text-primary">{year}</span>
                </div>
                <div className="flex-1 h-px bg-border" />
                <span className="text-sm text-muted-foreground">
                  {yearProjects?.length} {yearProjects?.length === 1 ? 'Project' : 'Projects'}
                </span>
              </div>
              {index < years?.length - 1 && (
                <div className="absolute left-5 md:left-6 top-12 md:top-14 bottom-0 w-px bg-border" />
              )}
              <div className="ml-12 md:ml-16 space-y-3">
                {yearProjects?.map((project) => (
                  <div
                    key={project?.id}
                    className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-muted/50 hover:bg-muted transition-colors duration-300"
                  >
                    <Icon name="CheckCircle2" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm md:text-base font-medium text-foreground mb-1 line-clamp-1">
                        {project?.title}
                      </h4>
                      <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                        {project?.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectTimeline;